import script from "./FavoritePublishers.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritePublishers.vue?vue&type=script&setup=true&lang=js"

import "./FavoritePublishers.vue?vue&type=style&index=0&id=6ca2f0de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca2f0de"]])

export default __exports__